import { IconButton, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PersonIconButton = styled(IconButton)(() => ({
  margin: 0,
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  width: "92%",
  maxWidth: "960px",
  minHeight: "min(85vh, 640px)",
  maxHeight: "calc(100vh - 100px)",
  margin: "auto",
  marginTop: "40vh",
  transform: "translateY(-40%)",
  background: "white",
  padding: "15px",
  borderRadius: "15px",
  transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease-out",
  opacity: 1,
  position: "relative",
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.down("md")]: {
    width: "92%",
    maxWidth: "500px",
  },

  ".modal-content": {
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "stretch",
    gap: "15px",
    overflowY: "auto",

    [theme.breakpoints.down("md")]: {
      gap: 0,
    },
  },

  ".inner-root": {
    flex: "45 1 0",
    minWidth: 0,
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
  },

  ".auth-graphic": {
    flex: "55 1 0",
    minWidth: 0,
    alignSelf: "center",
    height: "auto",
    maxHeight: "100%",
    objectFit: "contain",
    objectPosition: "center",
    display: "block",
    borderRadius: "10px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

export const SigninContainer = styled(Box)(({ theme }) => ({
  padding: "2px",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  ".form-root": {
    maxWidth: "380px",
    marginRight: "auto",
    paddingTop: "16px",
    paddingBottom: "8px",

    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
    },

    "&.signup": {
      position: "relative",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      minHeight: "580px",
      width: "100%",
    },

    ".signup-content": {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  },

  ".logo-img": {
    width: "130px",
    marginBottom: "10px",
  },

  ".login-title": {
    fontSize: "32px",
    fontFamily: "Gambarino",
    lineHeight: "115%",
    //color: theme.palette.customColor.main,
    marginBottom: "15px",
  },

  ".signup-link": {
    display: "flex",
    alignItems: "center",

    ".signup-text": {
      fontFamily: "Roundo-Regular",
      fontSize: "16px",
      fontWeight: "500",
      //color: theme.palette.customColor.secondary,
    },
    ".signup-btn": {
      fontFamily: "Roundo-Regular",
      fontSize: "16px",
      fontWeight: "500",
      marginLeft: "4px",
      //color: theme.palette.customColor.purple,
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: 0,
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },

  ".login-form": {
    marginTop: "10px",
  },

  ".forgot-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "38px",

    ".remember-check": {
      ".MuiTypography-root": {
        fontFamily: "Roundo-Regular",
        fontSize: "16px",
        fontWeight: "500",
        //color: theme.palette.customColor.main,
        marginTop: "2px",
      },
    },
  },

  ".google-btn, .microsoft-btn": {
    marginTop: "15px",

    "> span": {
      marginTop: "0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    svg: {
      width: "22px",
      height: "22px",
      marginBottom: "2px",
      marginRight: "8px",
    },
  },

  ".stepper-root": {
    width: "100%",
    marginBottom: "24px",

    ".MuiSvgIcon-root.Mui-active": {
      //color: theme.palette.customColor.purple,
    },

    ".MuiSvgIcon-root.Mui-completed": {
      //color: theme.palette.customColor.purple,
    },

    ".MuiStepLabel-label.Mui-active": {
      //color: theme.palette.customColor.secondary,
    },

    ".MuiStepLabel-label.Mui-completed": {
      //color: theme.palette.customColor.secondary,
    },
  },

  ".custom-select": {
    marginTop: "12px",
    marginBottom: "8px",
  },

  ".custom-helper-text": {
    fontFamily: "'Inter', system-ui, sans-serif",
    color: "rgba(0, 0, 0, 0.6)",
    fontSize: "0.75rem",
    lineHeight: "1.66",
    textAlign: "left",
    marginTop: "3px",
    marginTight: "14px",
    marginTottom: "0",
    marginLeft: "14px",
  },

  ".success-second-text": {
    fontFamily: "Roundo-Regular",
    fontSize: "16px",
    fontWeight: "500",
    //color: theme.palette.customColor.secondary,
    marginTop: "-25px",
    marginBottom: "30px",
  },
}));
